import type { TaxMode } from "@/api/AppApi/services/company/interfaces/tax";

export const getTaxLabelKey = (mode?: TaxMode): "tax_included" | "tax" =>
  mode === "inclusive" ? "tax_included" : "tax";
